import create from 'zustand'
import { safeLocalStorage } from '../safeStorage'

const IS_COLLAPSED_KEY = 'isNavbarCollapsed'

const getInitialCollapsedValue = () => {
  const isCollapsed = safeLocalStorage.getItem(IS_COLLAPSED_KEY)
  if (isCollapsed !== null && isCollapsed !== undefined && isCollapsed === 'true') {
    return true
  }

  return false
}

export const useNavbarCollapsedStore = create<any>(set => ({
  isCollapsed: getInitialCollapsedValue(),
  userCollapsedIt: getInitialCollapsedValue(),
  stateSnapshot: {
    isCollapsed: getInitialCollapsedValue(),
    userCollapsedIt: getInitialCollapsedValue(),
  },
  toggleCollapsedMode: () =>
    set(state => {
      const nextState = !state.isCollapsed
      safeLocalStorage.setItem(IS_COLLAPSED_KEY, String(nextState))

      return { isCollapsed: nextState, userCollapsedIt: nextState }
    }),
  setCollapsed: isCollapsed =>
    set(state => {
      return { isCollapsed }
    }),
  saveSnapshot: () =>
    set(state => {
      return { stateSnapshot: { isCollapsed: state.isCollapsed, userCollapsedIt: state.userCollapsedIt } }
    }),
  restoreSnapshot: () =>
    set(state => ({ isCollapsed: state.stateSnapshot.isCollapsed, userCollapsedIt: state.stateSnapshot.userCollapsedIt })),
}))
